<template>
  <div class="fill-height">
    <!-- Back button -->
    <div
      class="d-flex flex-row align-center"
      style="max-width: 600px; margin: 15px auto 0 auto;"
    >
      <v-btn class="mb-4" icon @click="goBack">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <div class="text-h6 text-center mb-4">{{ studyList.name }}</div>
    </div>
    <Player />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import store from "@/store";

import Player from "@/components/Player.vue";
import PlayerService from "@/common/player.service";

export default {
  name: "AudioStudy",
  props: {
    id: {
      required: true,
    },
  },
  beforeRouteEnter(to, _, next) {
    Promise.all([store.dispatch("fetchStudyList", to.params.id)]).then(() => {
      next((vm) => {
        vm.onStudyClick(vm.studyList);
      });
    });
  },
  computed: mapGetters(["studyList", "loggedIn"]),
  methods: {
    ...mapActions(["play", "stop", "updatePlayingInfo"]),
    onStudyClick(item) {
      PlayerService.setCurrentStudyList(item.id);
      this.updatePlayingInfo({ subtitle: item.name });
      this.play();
    },
    // Go back
    goBack() {
      this.stop();
      this.$router.go(-1);
    },
  },
  components: {
    Player,
  },
};
</script>
